import { Box } from '@mui/material';
import { GetStartedButton } from '../general';
import { PROJECT_NAME } from '../../config';

const StartNow = () => {
    return (
        <Box sx={{width: '100%'}}>
            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: 2, minHeight: '60vh'}}>
                <Box>
                    <span className='h1-style'>Start using {PROJECT_NAME} for free today &#9889;</span>
                </Box>
                <Box sx={{width: '100%'}}>
                    <GetStartedButton/>
                </Box>
            </Box>
        </Box>
    );
}

export default StartNow;